import { Component, OnInit, Input, ViewChild, ElementRef } from "@angular/core";
import { Account, Plans } from "src/models/account.model";
import { createPopper } from "@popperjs/core";
import { Router } from "@angular/router";
import Swal from "sweetalert2";
import { AuthService } from "src/services/auth.service";
import { User } from "src/models/user.model";
import { AccountService } from "src/services/account.service";
import { PlanService } from "src/services/plan.service";
import { combineLatest } from "rxjs";

@Component({
  selector: "app-card-accounts",
  templateUrl: "./card-accounts.component.html",
})
export class CardAccountsComponent implements OnInit {

  //@Input()
  // dropdownPopoverShow = false;
  @ViewChild("btnDropdownRef", { static: false }) btnDropdownRef: ElementRef;
  @ViewChild("popoverDropdownRef", { static: false })
  popoverDropdownRef: ElementRef;

  get color(): string {
    return this._color;
  }
  set color(color: string) {
    this._color = color !== "light" && color !== "dark" ? "light" : color;
  }
  private _color = "light";

  accounts: Account[] = [];
  filteredAccounts: Account[] = [];
  plans: Plans[] = [];
  userAuth: User;

  // Pagination
  currentPage = 1;
  itemsPerPage = 5;
  totalItems = 0;

  constructor(
    private accountService: AccountService,
    private planService: PlanService,
    protected router: Router,
    public auth: AuthService
  ) {

    this.auth.user$.subscribe(user => this.userAuth = user);

    combineLatest(this.accountService.getAccounts(), this.planService.getPlans())
      .subscribe(([accounts, plans]: any) => {

        plans.forEach((p, i) => {
          accounts.forEach((a, j) => {
            if (a.plan_id == p.id) {
              accounts[j].plan = p.name;
            }
          });
          console.log("accounts =>", this.accounts);
          console.log("plans =>", this.plans);
        });

        //this.plans = plans;
        this.accounts = accounts;
        this.applyPagination();

      });
  }

  ngOnInit(): void { }

  formatAddress(address: any): string {
    if (!address) return 'Not Available';

    const parts = [];
    if (address.street_house_building_number) parts.push(address.street_house_building_number);
    if (address.city) parts.push(address.city);
    if (address.province) parts.push(address.province);

    return parts.join(', ') || 'Not Available';
  }

  async edit(account: Account) {
    if (this.auth.canEdit(this.userAuth)) {
      await this.router.navigateByUrl('/admin/accounts/accounts-edit/' + account.uid);
    } else {
      await Swal.fire(
        'Warning',
        "Sorry, access denied. Please contact admin.",
        'warning'
      )
    }
  }

  async add() {
    if (this.auth.canEdit(this.userAuth)) {
      await this.router.navigateByUrl('/admin/accounts/accounts-add');
    } else {
      await Swal.fire(
        'Warning',
        "Sorry, access denied. Please contact admin.",
        'warning'
      )
    }
  }

  async delete(account: Account) {
    if (this.auth.canDelete(this.userAuth)) {
      if (account.uid) {

        await Swal.fire({
          title: 'Are you sure?',
          text: 'You will not be able to recover this account!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          cancelButtonText: 'No, keep it'
        }).then((result) => {
          if (result.isConfirmed) {

            this.accountService.deleteAccount(account).then(() => {
              Swal.fire(
                'Success',
                'Account deleted!',
                'success'
              )
            });

          } else if (result.dismiss === Swal.DismissReason.cancel) {

          }

        })

      }
    } else {
      await Swal.fire(
        'Warning',
        "Sorry, access denied. Please contact admin.",
        'warning'
      )
    }
  }

  applyPagination(): void {
    this.filteredAccounts = [...this.accounts];
    this.totalItems = this.filteredAccounts.length;
  }

  getPaginatedAccounts(): Account[] {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    return this.filteredAccounts.slice(startIndex, endIndex);
  }

  goToPage(page: number): void {
    if (page >= 1 && page <= this.getTotalPages()) {
      this.currentPage = page;
    }
  }

  getTotalPages(): number {
    return Math.ceil(this.totalItems / this.itemsPerPage);
  }

  getPageNumbers(): number[] {
    const totalPages = this.getTotalPages();
    const pages = [];
    const maxPages = 5;

    let startPage = Math.max(1, this.currentPage - Math.floor(maxPages / 2));
    let endPage = Math.min(totalPages, startPage + maxPages - 1);

    if (endPage - startPage < maxPages - 1) {
      startPage = Math.max(1, endPage - maxPages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    return pages;
  }

  getPaginationEndIndex(): number {
    return Math.min(this.currentPage * this.itemsPerPage, this.totalItems);
  }
}
